/* eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Globe,
  Info,
  Map,
  Shield,
  Link as LinkIcon,
  Eye,
  EyeOff,
  Filter,
  Check,
  RefreshCw,
} from "lucide-react";
import { useSelector } from "react-redux";
import { doc, setDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import Swal from "sweetalert2";
import axios from "axios";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ActivationCloakingCountries({ close }) {
  const store = useSelector((state) => state.StoreReducer);
  const user = useSelector((state) => state.userReducer.user);
  const account = useSelector((state) => state.AccountReducer);
  const products = useSelector((state) => state.ProductsReducer || []);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    cloakingActive: false,
  });

  const showAlert = (
    icon,
    title,
    text,
    showCancelButton = false,
    confirmButtonText = t("servicePageActivation.confirmChat.alerts.ok")
  ) => {
    return Swal.fire({
      icon,
      title,
      text,
      confirmButtonText,
      cancelButtonText: t("servicePageActivation.confirmChat.alerts.annuler"),
      showCancelButton,
      confirmButtonColor: "rgb(141, 93, 167)",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true,
      backdrop: `
          rgba(0,0,0,0.7)
        `,
      position: "center",
      customClass: {
        popup: "swal-popup-on-top",
        backdrop: "swal-backdrop-on-top",
        container: "swal-container-on-top",
      },
      willOpen: () => {
        // Ensure this alert appears on top of everything
        document.querySelector(".swal2-container").style.zIndex = "9999999999";
      },
    });
  };



  useEffect(() => {
    if (store) {
      setData({
        cloakingActive: store.cloakingActive || false,
      });
    }
  }, [store]);

  const handleDChange = () => {
    setData({
      ...data,
      cloakingActive: !data.cloakingActive,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const documentId = user?.uid || store?.id;

      if (!documentId) {
        throw new Error(t("servicePageActivation.cloakingcountries.benefits.alerts.storeIdNotFound"));
      }

      await setDoc(
        doc(db, "store", documentId),
        { cloakingActive: data.cloakingActive },
        { merge: true }
      );

      setLoading(false);

      if (data.cloakingActive) {
        await showAlert("success", t("servicePageActivation.cloakingcountries.benefits.alerts.activated"));
      } else {
        await showAlert("success", t("servicePageActivation.cloakingcountries.benefits.alerts.deactivated"));
      }
      close();
    } catch (error) {
      setLoading(false);
      await showAlert(
        "error",
        t("servicePageActivation.cloakingcountries.benefits.alerts.errorTitle"),
        t("servicePageActivation.cloakingcountries.benefits.alerts.errorDescription")
      );
      console.error("Error saving Cloaking settings:", error);
    }
  };

  const cloakingBenefits = [
    {
      icon: <Shield className="text-[#9e68ba]" size={18} />,
      title: t("servicePageActivation.cloakingcountries.benefits.0.title"),
      description:
        t("servicePageActivation.cloakingcountries.benefits.0.description"),
    },
    {
      icon: <Globe className="text-[#9e68ba]" size={18} />,
      title: t("servicePageActivation.cloakingcountries.benefits.1.title"),
      description: t("servicePageActivation.cloakingcountries.benefits.1.description"),
    },
    {
      icon: <Filter className="text-[#9e68ba]" size={18} />,
      title: t("servicePageActivation.cloakingcountries.benefits.2.title"),
      description: t("servicePageActivation.cloakingcountries.benefits.2.description"),
    },
  ];

  return (
    <div className="min-h-[400px] h-fit p-6"  >
      {account?.subscription?.plan !== "الأسطورية" ? (
        <div className="flex flex-col justify-center items-center py-16 text-center">
          <h2 className="text-lg font-bold text-[#9e68ba] dark:!text-[#b47ed6] mb-3">
            {t("servicePageActivation.cloakingcountries.upgradeTitle")}
          </h2>
          <p className="text-gray-600 dark:!text-gray-400 text-sm mb-5">
            {t("servicePageActivation.cloakingcountries.upgradeDescription")}
          </p>
          <Link
            to="/plan"
            className="bg-[#9e68ba] text-white px-6 py-2 rounded-lg hover:bg-[#814a9f] transition-colors text-sm font-medium"
          >
            {t("servicePageActivation.cloakingcountries.upgradeButton")}
          </Link>
        </div>
      ) : (
        <div className="bg-white dark:!bg-[#181919] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
          <div className="mb-6">
            <h3 className="text-xl font-bold text-[#9e68ba] dark:text-[#b47ed6] mb-2 flex items-center">
              <Globe className="ml-2" size={20} />
              {t("servicePageActivation.cloakingcountries.title")}
            </h3>
            <p className="text-gray-600 dark:text-gray-400 mb-4">
              {t("servicePageActivation.cloakingcountries.description")}
            </p>

            {/* Info Box principale */}
            <div className="bg-blue-50 dark:!bg-[#141414] rounded-lg border border-blue-200 dark:!border-[#3c3a3d] p-4 flex mb-6">
              <Info size={20} className="text-blue-500 ml-2 flex-shrink-0 mt-1" />
              <div>
                <p className="font-medium text-blue-800 dark:text-blue-300 mb-1">
                  {t("servicePageActivation.cloakingcountries.infoBoxTitle")}
                </p>
                <p className="text-blue-700 dark:text-blue-400 text-sm">
                  {t("servicePageActivation.cloakingcountries.infoBoxDescription")}
                </p>
              </div>
            </div>

            {/* Info Box - lien produit */}
            <div className="bg-purple-50 dark:!bg-[#141414] rounded-lg border border-purple-200 dark:!border-[#3c3a3d] p-4 flex mb-6">
              <LinkIcon size={20} className="text-purple-500 ml-2 flex-shrink-0 mt-1" />
              <div>
                <p className="font-medium text-purple-800 dark:text-purple-300 mb-1">
                  {t("servicePageActivation.cloakingcountries.linkBoxTitle")}
                </p>
                <p className="text-purple-700 dark:text-purple-400 text-sm">
                  {t("servicePageActivation.cloakingcountries.linkBoxDescription1")}
                  <br />
                  <span className="font-mono text-xs break-words text-gray-800 dark:text-gray-300">
                    {t("servicePageActivation.cloakingcountries.linkBoxExample1")}
                  </span>
                  <br />
                  {t("servicePageActivation.cloakingcountries.linkBoxDescription2")}
                  <br />
                  <span className="font-mono text-xs break-words text-gray-800 dark:text-gray-300">
                    {t("servicePageActivation.cloakingcountries.linkBoxExample2")}
                  </span>
                </p>
              </div>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Toggle principal */}
            <div>
              <label className="block text-sm font-medium text-[#9e68ba] dark:text-[#b47ed6] mb-4">
                {t("servicePageActivation.cloakingcountries.toggleLabel")}
              </label>
              <div
                className={`p-4 rounded-lg border transition-colors cursor-pointer flex items-center ${data.cloakingActive
                    ? "bg-[#fcf6ff] border-purple-200 dark:!bg-[#181919] dark:!border-[#3c3a3d]"
                    : "bg-white border-gray-200 hover:bg-gray-50 dark:!bg-[#181919] dark:!border-[#3c3a3d] dark:hover:bg-[#141414]"
                  }`}
                onClick={handleDChange}
              >
                <div className="relative inline-block w-12 ml-3 align-middle select-none">
                  <input
                    type="checkbox"
                    checked={data.cloakingActive}
                    onChange={() => { }}
                    className="hidden"
                    id="toggle"
                  />
                  <label
                    htmlFor="toggle"
                    className={`block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer ${data.cloakingActive ? "bg-purple-400" : ""
                      }`}
                  >
                    <span
                      className={`block h-6 w-6 rounded-full bg-white shadow transform transition-transform duration-200 ease-in ${data.cloakingActive ? "rtl:-translate-x-6 ltr:translate-x-6" : "translate-x-0"
                        }`}
                    />
                  </label>
                </div>
                <div>
                  <p className="font-medium dark:text-gray-200">
                    {data.cloakingActive
                      ? t("servicePageActivation.cloakingcountries.toggleActive")
                      : t("servicePageActivation.cloakingcountries.toggleInactive")}
                  </p>
                  <p className="text-sm text-gray-500 dark:text-gray-400">
                    {data.cloakingActive
                      ? t("servicePageActivation.cloakingcountries.toggleSubActive")
                      : t("servicePageActivation.cloakingcountries.toggleSubInactive")}
                  </p>
                </div>
              </div>
            </div>

            {/* Avantages */}
            {data.cloakingActive && (
              <div className="space-y-4">
                <h4 className="font-medium text-[#9e68ba] dark:text-[#b47ed6]">
                  {t("servicePageActivation.cloakingcountries.benefitsTitle")}
                </h4>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  {cloakingBenefits.map((benefit, index) => (
                    <div
                      key={index}
                      className="bg-white dark:!bg-[#181919] rounded-lg p-4 border border-gray-200 dark:!border-[#3c3a3d] shadow-sm"
                    >
                      <div className="flex items-center mb-2">
                        {benefit.icon}
                        <h5 className="font-medium text-gray-800 dark:text-gray-200 mr-2 text-sm">
                          {benefit.title}
                        </h5>
                      </div>
                      <p className="text-xs text-gray-600 dark:text-gray-400">
                        {benefit.description}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Tips */}
            <div className="bg-yellow-50 dark:!bg-[#141414] p-4 rounded-lg border border-yellow-100 dark:!border-[#3c3a3d]">
              <h4 className="font-medium text-yellow-800 dark:text-yellow-300 mb-2 flex items-center text-lg">
                <Info size={18} className="ml-2" />
                {t("servicePageActivation.cloakingcountries.tipsBoxTitle")}
              </h4>
              <ul className="text-sm text-gray-700 dark:text-gray-400 space-y-2 mr-5 list-disc">
                <li>{t("servicePageActivation.cloakingcountries.tip1")}</li>
                <li>{t("servicePageActivation.cloakingcountries.tip2")}</li>
                <li>{t("servicePageActivation.cloakingcountries.tip3")}</li>
                <li>{t("servicePageActivation.cloakingcountries.tip4")}</li>
              </ul>
            </div>

            {/* Bouton */}
            <button
              type="submit"
              disabled={loading}
              className={`px-6 py-3 bg-[#9b59bf] hover:bg-[#814a9f] text-white rounded-lg transition-colors flex items-center ${loading ? "opacity-70 cursor-not-allowed" : ""
                }`}
            >
              {loading ? (
                <>
                  <RefreshCw className="animate-spin ml-2" size={18} />
                  {t("servicePageActivation.cloakingcountries.save")}
                </>
              ) : (
                <>
                  <Check className="ml-2" size={18} />
                  {t("servicePageActivation.cloakingcountries.saving")}
                </>
              )}
            </button>
          </form>
        </div>

      )}
    </div>
  );
}
